exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".playaudio {\n  position: absolute;\n  margin-top: -60px;\n  width: 300px;\n  background-color: whitesmoke;\n  height: 53px;\n  text-align: center;\n  color: #545c64;\n  cursor: pointer; }\n\n.loading {\n  position: absolute;\n  margin-top: -108px;\n  width: 300px;\n  background-color: whitesmoke;\n  height: 100px;\n  text-align: center;\n  color: #545c64; }\n\n.icone-play {\n  position: absolute;\n  top: 2px;\n  right: 50%;\n  width: 30px !important;\n  height: 30px !important;\n  font-size: 40px !important;\n  color: darkslateblue;\n  cursor: pointer; }\n\n.md-icon:hover {\n  color: mediumpurple; }\n\n.player-width-device {\n  width: 230px; }\n\n.player-width-desktop {\n  width: 300; }\n\n@media (max-width: 450px) {\n  .player-width-device {\n    width: 230px; }\n  .player-width-desktop {\n    width: 300px; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/components/mediaplayer/mediaplayer.component.scss
// module id = ../../../../../src/app/components/mediaplayer/mediaplayer.component.scss
// module chunks = main